<div class="container">
  <form [formGroup]="personalInfo" (ngSubmit)="updatePrivatePerson()">
    <div class="double-field-container">
      <mat-form-field appearance="outline" class="names-container-item">
        <mat-label>
          Imię
        </mat-label>
        <input matInput formControlName="name" id="name" required/>
        <mat-error *ngIf="personalInfo.get('name').hasError('required')">
          Imię jest wymagane
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="names-container-item">
        <mat-label>
          Drugie imię
        </mat-label>
        <input matInput formControlName="secondName" id="secondName"/>
      </mat-form-field>
    </div>
    <div class="double-field-container">
      <mat-form-field appearance="outline">
        <mat-label>
          Nazwisko
        </mat-label>
        <input matInput formControlName="surname" id="surname" required/>
        <mat-error *ngIf="personalInfo.get('surname').hasError('required')">
          Nazwisko jest wymagane
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          PESEL
        </mat-label>
        <input matInput formControlName="pesel" id="pesel"/>
        <mat-error
          *ngIf="
                personalInfo.get('pesel').hasError('pattern') ||
                personalInfo.get('pesel').hasError('minlength') ||
                personalInfo.get('pesel').hasError('maxlength')">
          Podaj poprawny numer PESEL
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          Zewnętrzne ID
        </mat-label>
        <input matInput formControlName="individualNumber" id="individualNumber"/>
      </mat-form-field>
    </div>
    <div>
      <button *ngIf="standalone"
              mat-raised-button
              color="primary"
              [disabled]="!personalInfo.valid"
              class="width-100"
              type="submit"
              id="submit">
      <span class="color-white">
        Zmień dane
      </span>
      </button>
    </div>
    <div class="emails">
      <h1>Emaile</h1>
      <app-customer-email *ngFor="let email of privatePerson.emails.data" [email]="email"
                          (deleteEvent)="deleteEmail($event)"></app-customer-email>
      <button mat-raised-button
              class="width-100 create-button"
              type="button"
              color="primary"
              action-button
              [action]="addEmail.bind(this)">
        Dodaj email
      </button>
    </div>
    <div class="phones">
      <h1>Telefony</h1>
      <app-customer-phone *ngFor="let phone of privatePerson.phones.data" [phone]="phone"
                          (eventDelete)="deletePhone($event)"></app-customer-phone>
      <button mat-raised-button
              class="width-100 create-button"
              type="button"
              color="primary"
              action-button
              [action]="addPhone.bind(this)">
        Dodaj telefon
      </button>
    </div>
    <app-address-info *ngFor="let address of privatePerson.addresses.data" [address]="address" (eventDelete)="deleteAddress($event)"
                      [label]="address.type.label"></app-address-info>
    <button mat-raised-button
            class="width-100 create-button"
            type="button"
            color="primary"
            action-button
            [action]="addAddress.bind(this)">
      Dodaj adres
    </button>
  </form>
</div>
